import { Routes } from '@angular/router';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { NoAuthGuardService } from './guards/auth-guard.service';
import { LegalsComponent } from './components/legals/legals.component';
import { LostPasswordComponent } from './components/login/lostpassword/lostpassword.component';
import { PublicComponent } from './components/public/public.component';
import { menuConfig } from './config/menu-config';
import { TarteaucitronComponent } from './components/tarteaucitron/tarteaucitron.component';

export const PublicRoutes: Routes = [
    {
        path: '',
        component: LandingComponent,
        canActivate: [NoAuthGuardService]
    },
    {
        path: '',
        component: PublicComponent,
        children: [
            {
                path: 'login',
                children: [
                    {
                        path: '',
                        component: LoginComponent,
                        canActivate: [NoAuthGuardService],
                        data: {
                            menuItems: menuConfig.publicLogin
                        }
                    },
                    {
                        path: 'lostpassword',
                        component: LostPasswordComponent,
                        canActivate: [NoAuthGuardService],
                        data: {
                            menuItems: menuConfig.publicLostPassword
                        }
                    }
                ]
            },
            {
                path: 'legals/:type',
                component: LegalsComponent,
                data: {
                    menuItems: menuConfig.publicLegals
                }
            },
            {
                path: 'registration',
                component: RegistrationComponent,
                data: {
                    menuItems: menuConfig.publicRegistration
                }
            },
            {
                path: 'cookies',
                component: TarteaucitronComponent,
                data: {
                    menuItems: menuConfig.publicCookies
                }
            },
            {
                path: '**',
                redirectTo: ''
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/app.route.public.ts